<template>
  <modal-block modal-id="ModalRoomPrice" close-button="yes">
    <template v-slot:content>
      <div class="contentBox">
        <page-header :iconsize="this.$screen.height>600?40:30" o icon="ruble-circle-underline">
          <template v-slot:title>ЦЕНЫ НА РАЗМЕЩЕНИЕ</template>
          <template v-slot:text>
            <div class="roomName" style="padding-top: 6px">
              <span  style="font-size: 20px; font-weight: lighter;">НОМЕР  </span><span style="font-size: 20px; font-weight: bold; text-transform: uppercase">«{{$store.state.rooms[$store.state.bookingRoom].name}}»</span>
            </div>

<!--            <div v-if="['comfortDBL','comfortTWIN'].includes($store.state.bookingRoom[0])" class="ozp" style="padding-top: 6px">-->
<!--              <p style="font-size: 18px; color: red; font-weight: bold; text-transform: uppercase">АКЦИЯ до 28.02.2026</p>-->
<!--              <div>-->
<!--                <p style="padding-top: 10px; font-weight: bold; font-size: 16px">ОЗДОРОВИТЕЛЬНАЯ ПУТЕВКА</p>-->
<!--                <span style="font-size: 14px; font-weight: bold">ЦЕНА ЗА 1 ГОСТЯ </span>-->
<!--                <span style="font-size: 22px; color: #ed4141; padding-right: 15px; text-transform: uppercase" class="discountPrice">{{4000 * 1.6}} руб.</span>-->
<!--                <span style="font-size: 22px; color: #05bc1a; font-weight: bold;  text-transform: uppercase">4000 руб.</span>-->
<!--                <p style="padding-top: 10px; font-weight: bold; font-size: 16px">НЕ БОЛЕЕ 2 ГОСТЕЙ В НОМЕРЕ</p>-->
<!--              </div>-->
<!--              <p style="padding-top: 10px"><b>В СТОИМОСТЬ ВХОДИТ:</b> ПРОЖИВАНИЕ, ТРЕХРАЗОВОЕ ПИТАНИЕ, СПА-КОМПЛЕКС (БАССЕЙН,ДЖАКУЗИ, ХАММАМ), СПЕЛЕОКАМЕРА, ИНГАЛЯЦИИ, КИСЛОРОДНЫЙ КОКТЕЙЛЬ, ПРИЕМ МИНЕРАЛЬНОЙ ВОДЫ</p>-->

<!--            </div>-->


            <p style="padding-top: 10px; font-weight: bold; font-size: 16px">САНАТОРНО-КУРОРТНАЯ ПУТЕВКА</p>
            <p style="padding-top: 10px"><b>В СТОИМОСТЬ ВХОДИТ:</b> ПРОЖИВАНИЕ, ЛЕЧЕНИЕ, ТРЕХРАЗОВОЕ ПИТАНИЕ,  СПА-КОМПЛЕКС (БАССЕЙН,ДЖАКУЗИ, ХАММАМ)</p>



           <div v-if="isFamilyLux" class="familyNote" style="padding-top: 6px">
             <p style="font-size: 18px; color: red; font-weight: bold; text-transform: uppercase">МИНИМАЛЬНАЯ СТОИМОСТЬ НОМЕРА В СУТКИ ОТ</p>
             <div>
               <span style="font-size: 22px; color: #ed4141; padding-right: 15px; text-transform: uppercase" class="discountPrice">{{20000 * 1.6}} руб.</span>
               <span style="font-size: 22px; color: #05bc1a; font-weight: bold; text-transform: uppercase">20 000 руб.</span>
             </div>
             <div style="font-size: 14px; color: #956209; padding-top: 6px">
             <p style="margin: 0 0 6px">Номер рассчитан на размещение до 4 гостей:</p>
             <p style="margin: 0 0 6px">— 1 двуспальная кровать<br>— 2 односпальные кровати</p>
             <p style="margin: 0 0 6px">Стоимость номера рассчитывается исходя из минимального размещения 4 человек.</p>
             <p style="margin: 0 0 6px; font-weight: bold">Минимальная стоимость проживания — 20 000 ₽ за номер в сутки, даже при размещении 1, 2 или 3 гостей.</p>
             <p style="margin: 0">Дополнительные места в номере не предусмотрены.</p>
             </div>
            </div>




          </template>
        </page-header>
        <div class="content" :class="$screen.device">
          <div id="RoomPrice" :class="$screen.device">

            <div class="dateNav noSelect">
              <div @click="nav('minus')" class="btn"><img :src="require('@/assets/icons/left-arrow.png')"></div>
              <div  class="label"><span v-if="showPrice">{{price[activePrice].label}}</span></div>
              <div @click="nav('plus')" class="btn"><img :src="require('@/assets/icons/right-arrow.png')"></div>
            </div>
            <p class="discount" v-if="isFamilyLux && !showSummerPromo">В НАСТОЯЩИЙ МОМЕНТ ДЛЯ ЭТОЙ КАТЕГОРИИ НОМЕРОВ ДЕЙСТВУЕТ ПРОМО ЦЕНА</p>

            <div class="table" :class="{ summerPromo: showSummerPromo }">
              <div class="item" :class="{ summerPromo: showSummerPromo }">
                <div class="label"><img class="icon" :src="require('@/assets/icons/adult.png')"><span class="name" :style="{fontSize: labelFontSize+'px'}">ВЗРОСЛЫЙ</span><span class="desc"  :style="{fontSize: placeFontSize+'px'}">(ОСНОВНОЕ МЕСТО)</span></div>
                <div v-if="showPrice" class="price">
                  <template v-if="showSummerPromo">
                    <span class="discountPrice">{{ getRoomPrice('adultMain') }} руб.</span>
                  </template>
                  <template v-else>
                    <span class="discountPrice" v-if="isFamilyLux">{{ getRoomPrice('adultMain') * 1.6 }} руб.</span>
                    <span class="normalPrice" :class="{ familyLux: isFamilyLux }">{{ getRoomPrice('adultMain') }} руб.</span>
                  </template>
                </div>
                <div v-if="showPrice && showSummerPromo" class="price promoCol">
                  <span class="promoPrice">{{ getPromoPrice('adultMain') }} руб.</span>
                </div>
              </div>
              <div v-if="!isFamilyLux" class="item" :class="{ summerPromo: showSummerPromo }">
                <div class="label"><img class="icon" :src="require('@/assets/icons/adult.png')"><span class="name" :style="{fontSize: labelFontSize+'px'}">ВЗРОСЛЫЙ</span><span class="desc" :style="{fontSize: placeFontSize+'px'}">(ДОП МЕСТО)</span></div>
                <div v-if="showPrice" class="price">
                  <span v-if="showSummerPromo" class="discountPrice">{{ getRoomPrice('adultDop') }} руб.</span>
                  <span v-else>{{ getRoomPrice('adultDop') }} руб.</span>
                </div>
                <div v-if="showPrice && showSummerPromo" class="price promoCol">
                  <span class="promoPrice">{{ getPromoPrice('adultDop') }} руб.</span>
                </div>
              </div>
              <div class="item" :class="{ summerPromo: showSummerPromo }">
                <div class="label"><img class="icon" :src="require('@/assets/icons/kids.png')"><span class="name" :style="{fontSize: labelFontSize+'px'}">РЕБЕНОК (4-14 лет)</span><span class="desc" :style="{fontSize: placeFontSize+'px'}">(ОСНОВНОЕ МЕСТО)</span></div>
                <div v-if="showPrice" class="price">
                  <template v-if="showSummerPromo">
                    <span class="discountPrice">{{ getRoomPrice('childMain') }} руб.</span>
                  </template>
                  <template v-else>
                    <span class="discountPrice" v-if="isFamilyLux">{{ getRoomPrice('childMain') * 1.2 }} руб.</span>
                    <span class="normalPrice">{{ getRoomPrice('childMain') }} руб.</span>
                  </template>
                </div>
                <div v-if="showPrice && showSummerPromo" class="price promoCol">
                  <span class="promoPrice">{{ getPromoPrice('childMain') }} руб.</span>
                </div>
              </div>
              <div v-if="!isFamilyLux" class="item" :class="{ summerPromo: showSummerPromo }">
                <div class="label"><img class="icon" :src="require('@/assets/icons/kids.png')"><span class="name" :style="{fontSize: labelFontSize+'px'}">РЕБЕНОК (4-14 лет)</span><span class="desc" :style="{fontSize: placeFontSize+'px'}">(ДОП МЕСТО)</span></div>
                <div v-if="showPrice" class="price">
                  <span v-if="showSummerPromo" class="discountPrice">{{ getRoomPrice('childDop') }} руб.</span>
                  <span v-else>{{ getRoomPrice('childDop') }} руб.</span>
                </div>
                <div v-if="showPrice && showSummerPromo" class="price promoCol">
                  <span class="promoPrice">{{ getPromoPrice('childDop') }} руб.</span>
                </div>
              </div>
              <div v-if="!isFamilyLux" class="item" :class="{ summerPromo: showSummerPromo }">
                <div class="label"><img class="icon" :src="require('@/assets/icons/door.png')"><span class="name" :style="{fontSize: labelFontSize+'px'}">ОДНОМЕСТНОЕ</span><span class="desc" :style="{fontSize: placeFontSize+'px'}">(ОДИН ЧЕЛОВЕК В НОМЕРЕ)</span></div>
                <div v-if="showPrice" class="price">
                  <span v-if="showSummerPromo" class="discountPrice">{{ getRoomPrice('single') }} руб.</span>
                  <span v-else>{{ getRoomPrice('single') }} руб.</span>
                </div>
                <div v-if="showPrice && showSummerPromo" class="price promoCol">
                  <span class="promoPrice">{{ getPromoPrice('single') }} руб.</span>
                </div>
              </div>

            </div>

            <p v-if="showSummerPromo" class="promoPriceNote">{{ summerPromo.priceNote }}</p>
            <v-btn @click="this.$commit('bookFromPrice')"  :style="{fontSize:$screen.width<375?'9px':'12px'} " :block="true" variant="contained-flat" :border="false" height="40"  size="small" color="primary">
              <p style="color: white">ЗАБРОНИРОВАТЬ ЭТОТ НОМЕР</p>
            </v-btn>

          </div>

          <div v-if="showSummerPromo" class="promoStrip" @click="openPromoModal">
            🔥 {{ summerPromo.shortLabel }} 🔥
          </div>

          <div class="paymentRules">
            <div class="title">
              <img class="icon" :src="require('@/assets/icons/credit-card.png')">
              <span >ПРАВИЛА ОПЛАТЫ</span>
            </div>
            <p class="rule"><span>* </span>ДЛЯ ОФОРМЛЕНИИЯ БРОНИРОВАНИЯ НЕОБХОДИМО ВНЕСЕНИЕ ПРЕДОПЛАТЫ В РАЗМЕРЕ СТОИМОСТИ ОДНОГО ДНЯ ПРОЖИВАНИЯ ВСЕХ ГОСТЕЙ В НОМЕРЕ</p>
            <div v-if="showPaymentInfo" class="cards">
              <p>МЫ ПРИНИМАЕМ К ОПЛАТЕ ВСЕ КАРТЫ РОССИЙСКИХ БАНКОВ</p>
              <img  class="icon" :src="require('@/assets/img/payments.png')">
            </div>
          </div>

        </div>
      </div>
    </template>

  </modal-block>

</template>

<script>

import PageHeader from "@/components/PageHeader";
import ModalBlock from "@/components/ModalBlock";
import promotionsData from '@/data/promotions.json'


export default {
  name: 'ModalRoomPrice',
  components: {ModalBlock, PageHeader,},
  methods:{
    nav(n){

      let total= this.price.length
      let activePrice = this.activePrice+1
      let change = false
      if(n==='plus' && activePrice<total){this.activePrice=this.activePrice+1; change=true}
      if(n==='minus' && activePrice>1){this.activePrice=this.activePrice-1; change=true}

      if(change){
        this.showPrice = false
        setTimeout(()=>{this.showPrice=true},100)
      }



    },
    openPromoModal(){
      this.$commit('openPromoFromRoomPrice', this.summerPromo.id)
    },
    getRoomPrice(field){
      return this.price[this.activePrice].rooms[this.$store.state.bookingRoom][field]
    },
    getPromoPrice(field){
      const base = this.getRoomPrice(field)
      if(base === '' || base == null) return ''
      const discount = this.summerPromo?.discountPercent ?? 10
      return Math.round(base * (1 - discount / 100))
    }
  },
  computed:{
    currentRoom(){
      const room = this.$store.state.bookingRoom
      return Array.isArray(room) ? room[0] : room
    },
    isFamilyLux(){
      return this.currentRoom === 'familyLux'
    },
    summerPromo(){
      return promotionsData.promotions[0] || null
    },
    showSummerPromo(){
      if(!this.$store.state.promoIsActive) return false
      if(!this.summerPromo) return false
      if(!this.price[this.activePrice]?.promo) return false
      return !this.summerPromo.excludedRooms.includes(this.currentRoom)
    },
    labelFontSize(){
      let size = 14
      if(this.$screen.width < 400){size=11}
      return size

    },
    placeFontSize(){
      let size = 9
      if(this.$screen.width < 400){size=10}
      return size

    }
  },
  data: () => ({
    activePrice:0,
    showPrice:true,
    price: [],
    showPaymentInfo:false,
  }),
  mounted() {
    this.price = this.$store.state.price
  }
}
</script>


<style>
.discount{
  background-color: #02bd71;
  color: white;
  text-align: center;
  padding: 10px;
  margin-top: 5px;
  font-size: 14px;
}

.discountPrice{
  color: red;
  text-decoration: line-through;
}

.normalPrice.familyLux{
  color: #05bc1a;
  font-weight: bold;
}

.promoPrice{
  color: #05bc1a;
  font-weight: bold;
}

.promoPriceNote{
  color: #c77a00;
  text-align: center;
  padding: 8px 10px;
  margin: 0;
  font-size: 12px;
  font-weight: bold;
}

.Promo{
  background-color: #c77a00;
  color: white;
  text-align: center;
  padding: 10px;
  margin-top: 5px;
}

.Promo>.header{
  grid-auto-flow: column;
  display: grid;
  justify-content: center;
  column-gap: 5px;
  justify-items: center;
  align-content: center;
  align-items: center;
}

.Promo>.header>span{font-size: 24px; font-weight: bold}

.promoStrip{
  background-color: #c77a00;
  color: white;
  text-align: center;
  padding: 10px;
  margin-top: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

  #ModalRoomPrice{max-width: 650px; width: 100%;}
  #ModalRoomPrice.mobile{width: 100%; height: 100%}
  #ModalRoomPrice>.contentBox{overflow-y: auto}
  #ModalRoomPrice>.contentBox>.content{}
  /*#ModalRoomPrice>.contentBox>.content.mobile{padding: 20px}*/

  #RoomPrice{}
  #RoomPrice>.roomName{text-align: center; padding-top: 10px}
  #RoomPrice>.dateNav{display: grid; grid-template-columns: auto 1fr auto; background-color: white; align-items: center; border-bottom: 2px solid #3e3e3e}
  #RoomPrice>.dateNav>.btn{cursor:pointer; transition-duration:100ms; display: grid; background-color: #bd9f7a; height: 40px; width: 60px; align-items: center; justify-items: center}
  #RoomPrice.desktop>.dateNav>.btn:active{background-color: #e5c8a5;}
  #RoomPrice>.dateNav>.btn:hover{ background-color: #d2b28b;}
  #RoomPrice>.dateNav>.btn>img{height: 20px; filter: invert()}
  #RoomPrice>.dateNav>.label{text-align: center;}

  #RoomPrice>.table{}
  #RoomPrice>.table>.item{
    display: grid;
    grid-template-columns: 1fr auto;
    background-color: white;
    border-bottom: 1px solid #a19e9e;
  }

  #RoomPrice>.table>.item.summerPromo{
    grid-template-columns: 1fr auto auto;
  }

  #RoomPrice>.table>.item>.price.promoCol{
    background-color: #eef8ef;
    min-width: 90px;
    justify-content: center;
  }

  #RoomPrice>.table>.item.summerPromo > .price{
    min-width: 90px;
    justify-content: center;
    white-space: nowrap;
  }

  #RoomPrice>.table>.item>.label{padding: 4px 10px; background-color: #fdfcfc; display: grid; align-items: center; grid-auto-flow: column; justify-content: flex-start; column-gap: 4px}
  #RoomPrice>.table>.item>.label>.icon{height: 14px;}
  #RoomPrice>.table>.item>.label>.name{}
  #RoomPrice>.table>.item>.label>.desc{color: #7b7878;}

  #RoomPrice>.table>.item>.price{padding: 0px 10px; display: grid; align-items: center; background-color: #f1e7e7; grid-auto-flow: column; column-gap: 8px;}
  .paymentRules{padding: 0px 20px; padding-bottom: 20px; display: grid; row-gap: 8px;}
  .paymentRules>.rule{font-size: 12px; }
  .paymentRules>.title{padding-top: 10px; column-gap: 6px; height:40px; display: grid; grid-auto-flow: column; align-content: center; justify-content: center; align-items: center; justify-items: center }
  .paymentRules>.title>span{text-align: center; font-weight: lighter; font-size: 22px; line-height: 22px}
  .paymentRules>.title>.icon{height: 30px;}
  .paymentRules>.cards{display: grid; justify-content: center; justify-items: center; padding-top: 20px}
  .paymentRules>.cards>p{font-size: 13px; line-height: 13px; text-align: center}
  .paymentRules>.cards>img{height: 50px;}


  .ozp{padding: 10px 20px; background-color: rgba(255, 255, 255, 0.89);  text-align: center; border-radius: 10px; border: 4px solid #c31e1e;}
</style>